import React from 'react';
import LiveDropletCosts from './LiveDropletCosts';

const LiveDropletDashboard = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-cf-gray-900 mb-2">DigitalOcean Droplet Costs</h1>
        <p className="text-sm text-cf-gray-600">View and analyze your Droplet costs by region, tag, and more.</p>
      </div>

      <LiveDropletCosts />
    </div>
  );
};

export default LiveDropletDashboard; 